import { useMemo } from 'react';
import { ISelectOption } from '@constants/entities/ui';
import useProjectId from '@hooks/useProjectId';
import { useGetBusinessAttributesQuery } from '@store/services/nodes';

const useBusinessAttributesOptions = () => {
  const projectId = useProjectId(true);

  const { data, isLoading, isFetching } = useGetBusinessAttributesQuery({
    projectId,
  });

  const options: ISelectOption[] = useMemo(() => {
    return (data ?? []).map(({ id, name }) => ({ value: id, label: name }));
  }, [data]);

  return {
    options,
    isLoading: isLoading || isFetching,
  };
};

export default useBusinessAttributesOptions;
